module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_5.c1acffcc.png";